module.exports = __webpack_public_path__ + "img/wedss7.ee6495f0.jpg";